// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/vendors~" + chunkId + ".js?" + {"chartjs":"9fe6b0464564451d1f1f","ansi_up":"c3b32875873781bca34e"}[chunkId] + "";
};